import classNames from 'classnames/bind';
import React from 'react';
import { Navigate, Outlet, useMatch } from 'react-router-dom';
import { MY_CONTENT_ROUTES, ROUTES } from '../../Base.constants';
import SubHeader from '../../components/SubHeader';
import { SubheaderType } from '../../components/SubHeader/SubHeader.constants';
import { SUB_HEADER_TITLE } from './MyContent.constants';
import styles from './MyContent.module.scss';
import useGetMyContentRoutes from '../../hooks/myContentPreferences/useGetMyContentRoutes';

const cx = classNames.bind(styles);

const MyContent = (): React.ReactElement => {
  const isMyContentRoute = useMatch(ROUTES.myContent);
  const { routes } = useGetMyContentRoutes();

  if (isMyContentRoute) {
    return <Navigate to={MY_CONTENT_ROUTES.articles()} replace />;
  }

  return (
    <div className={cx('body')}>
      <SubHeader title={SUB_HEADER_TITLE} routes={routes} type={SubheaderType.MyContent} />
      <Outlet />
    </div>
  );
};

export default MyContent;
